<template>
  <v-footer color="#000" app>
    <v-row :align="alignment" :justify="justify">
      <v-col cols="12" md="12" style="max-width: 1280px;">
        <v-row>
          <template v-if="!$vuetify.breakpoint.xs">
            <v-col cols="12" md="12" style="height: 100px;">
              <v-col cols="12" md="1" class="body-1 footer_font float-left">联系我们</v-col>
              <v-col cols="12" md="2" class="body-1 footer_font float-left">
                <v-icon color="#FFF">mdi-phone</v-icon>&nbsp;&nbsp;+86 0531-66661761<br>
                <v-icon>mdi-phone</v-icon>&nbsp;&nbsp;+86 0531-66661762
              </v-col>
              <v-col cols="12" md="2" class="body-1 footer_font float-left">
                <v-icon color="#FFF">mdi-email</v-icon>&nbsp;&nbsp;admin@etoak.com<br>
                <v-icon>mdi-email</v-icon>&nbsp;&nbsp;ww@etoak.com
              </v-col>
              <v-col cols="12" md="3" class="body-1 footer_font float-left">
                <v-icon color="#FFF">mdi-home</v-icon>&nbsp;&nbsp;山东省济南市历下区<br>
                <v-icon>mdi-home</v-icon>&nbsp;&nbsp;趵突泉北路6号蓝石中心4层
              </v-col>
            </v-col>
          </template>
        </v-row>
        <v-row style="max-width: 1280px;">
          <v-col class="foot_font">
            Copyright © {{new Date().getFullYear()}} etoak.com. All Rights
            Reserved&nbsp;&nbsp;&nbsp;&nbsp;鲁ICP备16042106号
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-footer>
</template>
<style>
  .foot_font {
    font-family: 'Roboto,sans-serif';
    font-weight: 400;
    font-style: normal;
    color: #CCCCCC;
    line-height: 24px;
    font-size: 14px;
    text-align: center;
  }

  .footer_font {
    margin-right: 80px;
    color: #FFFFFF;
  }
</style>
<script>
  export default {
    name: 'account-footer',
    data() {
      return {
        alignment: 'center',
        justify: 'center',
        absolute: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/page/account/account-footer.vue